import React,{Component,Suspense,lazy} from 'react'
import {connect} from 'react-redux'
import {addToCart} from '../services/Actions/actions'
import Loding from "../components/Home_componets/Loding";
const Viewservice=lazy(()=>import('../components/Service_components/Viewservice'))

function ViewserviceContainer(props) {
    return (
        <div>
             <Suspense fallback={<div> <Loding/></div>}> 
                    <Viewservice {...props}/>    
            </Suspense> 
        </div>
    )
}

const mapStateToProps=state=>({
    data:state.addItems
})
const mapDispatchToProps=dispatch=>({
    

})
export default connect(mapStateToProps,mapDispatchToProps)(ViewserviceContainer)